import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { useSelector } from "react-redux";

// Configuración base de la gráfica
const chartSetting = {
  height: 350,
  width: 450,
  //   margin: { top: 80, bottom: 30, left: 40, right: 10 },
};

export default function BarChartSpecialist() {
  // Obtener la lista de usuarios desde Redux (ajusta según tu store)
  const { listSpecialist } = useSelector((state) => state.usersReducer);
  //   console.log("Lista de especialistas:", listSpecialist);

  // Contar usuarios por status de cuenta
  const accountStatusCounts = listSpecialist?.reduce(
    (acc, user) => {
      //   console.log("Usuario:", user);
      //   console.log("Estado de cuenta:", user.status);

      acc[user.status] = (acc[user.status] || 0) + 1;
      return acc;
    },
    { active: 0, inactive: 0, pending: 0 }
  );

  // Contar usuarios por status de membresía
  const membershipStatusCounts = listSpecialist?.reduce(
    (acc, user) => {
      acc[user.membershipStatus] = (acc[user.membershipStatus] || 0) + 1;
      return acc;
    },
    { active: 0, inactive: 0 }
  );

  // Dataset estructurado para la gráfica
  const dataset = [
    {
      category: "Cuenta",
      active: accountStatusCounts?.active || 0,
      inactive: accountStatusCounts?.inactive || 0,
      pending: accountStatusCounts?.pending || 0,
    },
    {
      category: "Membresía",
      active: membershipStatusCounts?.active || 0,
      inactive: membershipStatusCounts?.inactive || 0,
    },
  ];

  return (
    <BarChart
      dataset={dataset}
      //   layout=""
      xAxis={[
        {
          scaleType: "band",
          dataKey: "category",
          label: "Estado",
        },
      ]}
      series={[
        { dataKey: "active", label: "Activo", color: "#4CAF50" },
        { dataKey: "inactive", label: "Inactivo", color: "#F44336" },
        { dataKey: "pending", label: "Pendiente", color: "#FFC107" },
      ]}
      {...chartSetting}
      slotProps={{
        legend: {
          direction: "row",
          position: { vertical: "top", horizontal: "middle" },
          padding: 0,
        },
      }}
    />
  );
}
